
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_nr3gs_kgbet_5",
  "textarea": "awsui_textarea_nr3gs_kgbet_9",
  "content-editable": "awsui_content-editable_nr3gs_kgbet_13",
  "action-button": "awsui_action-button_nr3gs_kgbet_17",
  "primary-action": "awsui_primary-action_nr3gs_kgbet_21",
  "secondary-actions": "awsui_secondary-actions_nr3gs_kgbet_25",
  "secondary-content": "awsui_secondary-content_nr3gs_kgbet_29"
};
  